import { motion } from "framer-motion";
import { WhatsAppIcon } from "./Icons";
import { WHATSAPP_LINK } from "../../data/site";

const WhatsAppFloat = () => (
  <motion.a
    data-testid="whatsapp-float"
    href={WHATSAPP_LINK}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with us on WhatsApp"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.8, type: "spring", stiffness: 200, damping: 15 }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.95 }}
    className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.5)]"
  >
    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#25D366] opacity-30" />
    <WhatsAppIcon className="relative h-7 w-7" />
  </motion.a>
);

export default WhatsAppFloat;
